import React from "react";
import ReactDOM from "react-dom/client";
import "@/assets/styles/globals.css";
import "@/i18n";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import QueryProvider from "@/common/providers/query-provider";
import { Toaster } from "@/common/ui/sonner";
import { routeTree } from "@/routeTree.gen";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const rootEl = document.getElementById("root");
if (rootEl) {
	const root = ReactDOM.createRoot(rootEl);
	root.render(
		<React.StrictMode>
			<QueryProvider>
				<RouterProvider router={router} />
				<Toaster />
			</QueryProvider>
		</React.StrictMode>
	);
}
